export * from './alert.service';
export * from './authentication.service';
export * from './photoauth.service';
export * from './user.service';
export * from './home.service';
export * from './dashboard.service';
export * from './batch.service';
export * from './student.service';
export * from './exam.service';
export * from './lunchpage.service';
